/* tslint:disable */
export enum DocumentVisibilityType {
    Label = 1,
    MiraRole = 2,
    DrivingLicense = 4,
}